import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import Nav from "./Nav";
import { NotificationContainer, NotificationProvider } from "./Notifications";
import routes from "./Routes";
import Breadcrumbs from "./components/Breadcrumbs";
import { WebSocketProvider } from "./Websockets";
import { useSidebarSettings } from "./lib/sidebarSettings";
import { useEffect } from "react";

function Layout() {
  const location = useLocation();
  const [sidebarSettings, setSidebarSettings] = useSidebarSettings();

  // Force sidebar to be collapsed on rebalances routes
  const isRebalancesRoute = location.pathname.startsWith("/rebalances");
  const isCollapsed = isRebalancesRoute || sidebarSettings.isCollapsed;

  useEffect(() => {
    // If on rebalances route and sidebar is not collapsed, force collapse
    if (isRebalancesRoute && !sidebarSettings.isCollapsed) {
      setSidebarSettings({ isCollapsed: true });
    }
  }, [isRebalancesRoute, sidebarSettings.isCollapsed, setSidebarSettings]);

  const toggleSidebar = () => {
    if (!isRebalancesRoute) {
      setSidebarSettings({ isCollapsed: !sidebarSettings.isCollapsed });
    }
  };

  return (
    <div className="App">
      <Header />
      <Container fluid>
        <Row>
          <Nav
            isCollapsed={isCollapsed}
            onToggle={toggleSidebar}
            canToggle={!isRebalancesRoute}
          />
          <Col
            xl={isCollapsed ? 11 : 10}
            lg={isCollapsed ? 11 : 9}
            className="flex-lg-grow-1"
          >
            <main className="py-3 sentry-mask">
              {routes === null ? null : (
                <Breadcrumbs routes={routes} location={location.pathname} />
              )}
              <NotificationProvider>
                <WebSocketProvider>
                  <Outlet />
                  <NotificationContainer />
                </WebSocketProvider>
              </NotificationProvider>
            </main>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Layout;
